(() => {
  'use strict';
  const popup = document.getElementById('piex-event-popup');
  if (!popup || popup.dataset.ready) return;
  popup.dataset.ready = 'true';
  const end = Date.parse('2026-10-25T17:00:00-05:00');
  const key = 'piex:event:2026-10-25:dismissed';
  const mobile = window.matchMedia('(max-width: 767px)');
  let timer;
  let expiryTimer;
  let previousFocus;
  const dismissed = () => {
    try { return sessionStorage.getItem(key) === '1'; } catch (_) { return false; }
  };
  const close = (remember = true) => {
    clearTimeout(timer);
    clearTimeout(expiryTimer);
    if (remember) { try { sessionStorage.setItem(key, '1'); } catch (_) {} }
    if (popup.open) popup.close();
    if (previousFocus && previousFocus.isConnected && document.activeElement === popup.querySelector('button')) {
      previousFocus.focus({ preventScroll: true });
    }
  };
  popup.querySelector('button').addEventListener('click', () => close());
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  popup.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  const open = () => {
    if (Date.now() >= end || dismissed() || !popup.isConnected) return;
    const otherDialog = Array.from(document.querySelectorAll('dialog[open], modal-dialog[open], [role="dialog"][aria-modal="true"]'))
      .some(element => element !== popup && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
    if (document.hidden || otherDialog) {
      timer = setTimeout(open, 1000);
      return;
    }
    previousFocus = document.activeElement;
    popup.setAttribute('aria-modal', String(mobile.matches));
    if (mobile.matches) popup.showModal();
    else {
      popup.show();
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    }
    expiryTimer = setTimeout(() => close(false), Math.max(0, end - Date.now()));
  };
  mobile.addEventListener('change', () => {
    if (!popup.open) return;
    popup.close();
    popup.setAttribute('aria-modal', String(mobile.matches));
    if (mobile.matches) popup.showModal(); else popup.show();
  });
  const start = () => { if (Date.now() < end && !dismissed()) timer = setTimeout(open, 5000); };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
